import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import styled from "styled-components";
import trim from "lodash/trim";
import { Formik, Form } from "formik";
import i18n from "i18n";
import { ModalSubmit, FormikInput } from "components/common";
const FilterInput = styled(FormikInput)`
  margin-bottom: 5px;
`;
const Container = styled.div`
  padding: 3px 10px;
  max-width: 250px;
`;
const validate = ({ value }) => {
  if (!value || trim(value) === "") {
    return { value: i18n.t("filters.must_not_be_empty", { ns: "common" }) };
  }
  return {};
};
const GenericFilterInput = ({ filter = void 0, onSubmit }) => {
  const { t } = useTranslation("common");
  const initialValues = { value: filter == null ? void 0 : filter.value };
  const createFilter = useCallback(({ value }) => onSubmit({ title: value, value }, true), [onSubmit]);
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": "generic-filter-form" }, /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: createFilter, validate }, ({ isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    FilterInput,
    {
      type: "text",
      id: "generic-filters-input",
      name: "value",
      formGroupClassName: "",
      required: true,
      placeholder: t("filters.value_placeholder")
    }
  ), /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: filter ? t("filters.update_submit") : t("filters.create_submit"),
      bsSize: "small",
      disabledSubmit: !isValid,
      displayCancel: false
    }
  ))));
};
export default GenericFilterInput;
